import type { IMediaUsageEntity } from "../state/gallerySlice";
import type { IEntitiesToDisplayWarning, WarningEntity } from "../components/MediaModuleWarning";

export type MediaUsagePayload = Array<[IMediaUsageEntity[] | null, { mediaId: number }]>;

const groupKeyOf = (apiId: string, projectName?: string) =>
  apiId === "user" || apiId === "organization" ? apiId : `project:${projectName ?? ""}`;

export const buildMediaUsageEntities = (data: MediaUsagePayload): IEntitiesToDisplayWarning => {
  const groups = new Map<string, WarningEntity>();

  data.forEach(([usageEntities, { mediaId }]) => {
    (usageEntities ?? []).forEach((item) => {
      const apiId = item.apiId ?? "";
      const fieldName = item.fieldName ?? undefined;
      const projectName = item.projectName ?? undefined;
      const key = groupKeyOf(apiId, projectName);

      let entity = groups.get(key);
      if (!entity) {
        entity = { apiId, fieldName, projectName, usages: [] };
        groups.set(key, entity);
      }

      const existing = entity.usages.find(
        (usage) =>
          usage.mediaId === mediaId && usage.apiId === apiId && usage.fieldName === fieldName,
      );
      if (existing) {
        existing.count += 1;
      } else {
        entity.usages.push({ mediaId, apiId, fieldName, count: 1 });
      }
    });
  });

  const entities = Array.from(groups.values());

  return {
    projects: entities.filter(
      (entity) => entity.apiId !== "user" && entity.apiId !== "organization",
    ),
    users: entities.filter((entity) => entity.apiId === "user"),
    organizations: entities.filter((entity) => entity.apiId === "organization"),
  };
};
